import Styled from "styled-components";
const Div = Styled.div`
`;
const Content = Styled.div`
  padding:40px 24px;
  width:100%;
  padding-bottom:0;
  overflow: hidden;
  .collapsed-none{
    transition: all .2s;
  }
  .
`;

export {Content };
